import { Avatar, Stack, Typography } from '@mui/material';
import { CannabisContext } from 'Context/CannabisContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { StepIcon2 } from 'Images';
import { useContext } from 'react';

export const GettingStartNote = () => {
  const { isFileError } = useContext(CannabisContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();
  return (
    <>
      {isFileError ? (
        <Stack role='alert' textAlign={'center'} alignItems={'center'}>
          <Avatar
            src={StepIcon2}
            sx={{ width: '66px', height: '65px', mb: 2 }}
            alt=''
          />
          <Typography variant='h6' component='h2'>
            {dictionary.fileErrorTitle}
          </Typography>
          <Typography variant='body3' component='h3'>
            {dictionary.fileErrorSubTitle}
          </Typography>
        </Stack>
      ) : (
        isDesktop && (
          <Stack mt={4}>
            <Typography component={'p'} variant='body2'>
              {dictionary.gettingStarted1}
            </Typography>
            <Typography component={'p'} variant='body3'>
              {dictionary.gettingStarted2}
            </Typography>
          </Stack>
        )
      )}
    </>
  );
};
